function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.132 24.349C135.099 31.6349 134 41.0734 134 41.0734C134 41.0734 124.847 38.699 119.88 31.413C114.913 24.127 116.013 14.6886 116.013 14.6886C116.013 14.6886 125.165 17.063 130.132 24.349Z",
  fill: "#2F2E41"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.558 25.7402C127.139 34.5539 133.81 41.2855 133.81 41.2855C133.81 41.2855 139.54 33.7273 138.958 24.9136C138.377 16.0999 131.706 9.36829 131.706 9.36829C131.706 9.36829 125.976 16.9265 126.558 25.7402Z",
  fill: "#E9663A"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.5314 0.183524L136.967 34.2704C137.528 34.5538 137.993 34.9973 138.304 35.5452C138.615 36.0932 138.759 36.7212 138.716 37.3508L134.798 95.6988C134.781 95.9605 134.699 96.2138 134.561 96.436C134.422 96.6581 134.231 96.8424 134.004 96.9722C133.777 97.102 133.522 97.1733 133.261 97.1798C133 97.1863 132.742 97.1278 132.509 97.0095L63.5356 61.6192L67.0767 1.6059C67.0933 1.324 67.1793 1.05066 67.327 0.810437C67.4747 0.570216 67.6794 0.370636 67.9228 0.22962C68.1661 0.0886044 68.4405 0.0105691 68.7213 0.00252332C69.0021 -0.0055225 69.2804 0.0566728 69.5314 0.183524Z",
  fill: "#D0CDE1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.307 1.37254L136.086 34.6222C136.633 34.8986 137.087 35.3312 137.391 35.8657C137.694 36.4001 137.834 37.0128 137.793 37.6269L133.971 94.5417C133.954 94.797 133.874 95.044 133.739 95.2608C133.604 95.4775 133.417 95.6572 133.196 95.7838C132.975 95.9104 132.726 95.98 132.472 95.9864C132.217 95.9927 131.965 95.9356 131.738 95.8202L64.4585 61.2992L67.9126 2.75998C67.9288 2.485 68.0127 2.21838 68.1567 1.98406C68.3008 1.74974 68.5005 1.55506 68.7379 1.41751C68.9752 1.27995 69.2429 1.20384 69.5168 1.19599C69.7906 1.18814 70.0622 1.24881 70.307 1.37254Z",
  fill: "#3F3D56"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.1901 5.78883L132.817 35.9286C133.313 36.1792 133.724 36.5713 133.999 37.0558C134.274 37.5403 134.401 38.0956 134.364 38.6523L130.9 90.2439C130.884 90.4753 130.812 90.6993 130.689 90.8957C130.567 91.0922 130.398 91.2551 130.197 91.3699C129.997 91.4846 129.771 91.5477 129.54 91.5535C129.31 91.5592 129.081 91.5075 128.876 91.4028L67.8887 60.1106L71.0197 7.0465C71.0344 6.79724 71.1104 6.55555 71.241 6.34315C71.3716 6.13074 71.5526 5.95427 71.7678 5.82959C71.983 5.7049 72.2256 5.6359 72.4738 5.62879C72.7221 5.62167 72.9682 5.67667 73.1901 5.78883Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.6638 90.3299L79.1858 124.518C79.8142 124.836 80.5079 125.001 81.2113 125C81.9146 124.999 82.608 124.832 83.2355 124.513L133.186 99.0196C133.772 98.4307 133.69 97.558 133.503 96.9029C133.412 96.5857 133.288 96.2789 133.134 95.9878L126.327 92.3883L69.0969 63.6801L65.6777 61.8552C64.7725 61.3733 63.7645 61.1193 62.7402 61.1152C61.716 61.111 60.706 61.3568 59.7969 61.8313L11.6427 86.9798C11.3363 87.1391 11.0797 87.3805 10.9013 87.6773C10.7229 87.974 10.6297 88.3146 10.6319 88.6614C10.6341 89.0082 10.7316 89.3475 10.9137 89.642C11.0959 89.9365 11.3555 90.1746 11.6638 90.3299Z",
  fill: "#D0CDE1"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M11.6636 90.3299L79.1856 124.518C79.814 124.836 80.5078 125.001 81.2111 125C81.9145 124.999 82.6078 124.832 83.2354 124.513L133.186 99.0196C133.772 98.4307 133.69 97.558 133.503 96.9029L83.7013 122.928C83.0936 123.246 82.4198 123.414 81.7349 123.42C81.0501 123.426 80.3735 123.269 79.7605 122.962L10.6558 88.3485C10.5908 88.7437 10.6537 89.1495 10.8351 89.5061C11.0165 89.8628 11.3069 90.1515 11.6636 90.3299Z",
  fill: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M75.7531 100.573L53.886 89.4638C53.4457 89.2401 52.9584 89.1263 52.4652 89.1319C51.9719 89.1376 51.4873 89.2625 51.0523 89.4962L38.367 96.3097C38.2205 96.3884 38.0982 96.5061 38.0136 96.6499C37.929 96.7937 37.8853 96.9581 37.8873 97.1252C37.8892 97.2922 37.9368 97.4555 38.0247 97.5973C38.1127 97.739 38.2377 97.8538 38.386 97.929L60.6818 109.233C61.052 109.42 61.4625 109.514 61.877 109.504C62.2915 109.494 62.6973 109.382 63.0585 109.178L75.7944 101.964C75.9185 101.894 76.0212 101.791 76.0912 101.666C76.1613 101.541 76.1961 101.399 76.1918 101.256C76.1876 101.113 76.1444 100.974 76.0671 100.853C75.9898 100.733 75.8812 100.636 75.7531 100.573Z",
  fill: "black"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M127.253 98.7154L103.722 111.284C103.452 111.428 103.15 111.505 102.844 111.508C102.537 111.512 102.234 111.441 101.961 111.301L35.4754 77.4985C35.2881 77.4033 35.1308 77.2575 35.0212 77.0775C34.9116 76.8974 34.8541 76.6903 34.855 76.4792C34.8559 76.2682 34.9152 76.0615 35.0263 75.8825C35.1374 75.7034 35.2959 75.559 35.4841 75.4653L58.4627 64.0308C58.809 63.8585 59.1904 63.7695 59.5768 63.7709C59.9632 63.7723 60.344 63.864 60.6891 64.0388L127.243 97.7523C127.331 97.7971 127.406 97.8654 127.458 97.9497C127.51 98.0341 127.538 98.1313 127.54 98.2307C127.541 98.3301 127.514 98.4279 127.464 98.5134C127.413 98.5989 127.341 98.6688 127.253 98.7154Z",
  fill: "black"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.7137 36.0364L89.5957 36.2737L111.23 47.149L111.348 46.9117L89.7137 36.0364Z",
  fill: "#E9663A"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.7114 39.2259L89.5913 39.4619L111.231 50.5909L111.351 50.355L89.7114 39.2259Z",
  fill: "#E9663A"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.6728 45.3191L93.5527 45.5553L105.951 51.9245L106.071 51.6883L93.6728 45.3191Z",
  fill: "#E9663A"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.9366 58.5989C25.9366 58.5989 20.661 56.2877 18.183 58.7292C15.7051 61.1706 24.8175 60.3669 25.9366 58.5989Z",
  fill: "#3F3D56"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.8269 47.638C18.5998 44.6262 22.1073 44.4858 22.1073 44.4858C22.1073 44.4858 25.5252 44.0464 27.7178 48.6334C29.7615 52.9089 32.5819 57.0369 28.1719 58.0378L27.3753 55.5451L26.882 58.2234C26.2541 58.2688 25.6242 58.2796 24.9951 58.2558C20.2723 58.1025 15.7745 58.3006 15.9193 56.5968C16.1118 54.3317 15.121 50.536 16.8269 47.638Z",
  fill: "#2F2E41"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3461 102.237C14.3461 102.237 16.5842 106.416 18.023 106.416C19.4618 106.416 19.302 109.148 18.9822 109.791C18.6625 110.434 17.8632 111.881 19.1421 113.97C19.5888 114.7 19.5089 115.528 19.2158 116.296C18.3944 118.449 15.1993 117.797 15.3012 115.493C15.3023 115.468 15.3037 115.442 15.3053 115.417C15.4652 112.845 14.1862 108.827 12.9073 107.862C11.6283 106.898 10.5093 104.326 10.5093 104.326L14.3461 102.237Z",
  fill: "#FFB8B8"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.6933 101.272C29.6933 101.272 27.4552 105.451 26.0164 105.451C24.5776 105.451 24.7374 108.184 25.0572 108.827C25.3769 109.469 26.1762 110.916 24.8973 113.006C24.4506 113.735 24.5305 114.563 24.8236 115.332C25.645 117.485 28.8401 116.832 28.7382 114.529C28.7371 114.503 28.7357 114.478 28.7341 114.452C28.5742 111.88 29.8532 107.862 31.1321 106.898C32.4111 105.933 33.5301 103.362 33.5301 103.362L29.6933 101.272Z",
  fill: "#FFB8B8"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.9349 80.6992L28.8941 82.7886C28.8941 82.7886 42.9624 87.4498 41.6835 92.9145C40.4045 98.3793 34.1697 106.898 33.2105 106.576C32.2513 106.255 27.1355 105.291 26.9757 102.558C26.8158 99.8259 30.6526 95.004 30.6526 95.004L25.377 90.1822L17.7001 90.0214L11.1488 95.004C11.1488 95.004 18.0231 101.112 14.9856 103.523C11.9482 105.934 7.47188 107.541 6.83241 106.576C6.19294 105.612 -1.00109 91.3073 0.117983 90.0214C1.23705 88.7356 12.5876 83.9137 12.5876 83.9137L15.6251 79.5741L27.4553 78.9312L27.9349 80.6992Z",
  fill: "#2F2E41"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.0574 54.179C25.0574 54.179 24.2581 59.483 25.8567 60.1259C27.4554 60.7689 22.6594 63.5012 22.6594 63.5012H19.9416L18.1831 59.8045C18.1831 59.8045 19.7818 56.9114 18.8226 54.179C17.8634 51.4466 25.0574 54.179 25.0574 54.179Z",
  fill: "#FFB8B8"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M25.0574 54.179C25.0574 54.179 24.2581 59.483 25.8567 60.1259C27.4554 60.7689 22.6594 63.5012 22.6594 63.5012H19.9416L18.1831 59.8045C18.1831 59.8045 19.7818 56.9114 18.8226 54.179C17.8634 51.4466 25.0574 54.179 25.0574 54.179Z",
  fill: "black"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.1763 58.6793C26.1763 58.6793 24.4178 60.6081 24.0981 60.9295C23.7783 61.251 22.3395 63.019 19.302 60.4473C16.2646 57.8757 15.9448 60.9295 15.9448 60.9295V80.2169C15.9448 80.2169 18.5027 79.0918 20.581 80.2169C22.6592 81.342 26.9757 79.8955 26.9757 79.8955L27.775 59.9652L26.1763 58.6793Z",
  fill: "#D0CDE1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.0017 58.6793C25.0017 58.6793 26.4958 58.0364 27.7747 58.6793C29.0536 59.3222 33.5299 62.5368 33.2102 63.9833C32.8905 65.4299 28.7339 75.5558 31.6115 80.3777C34.4891 85.1995 34.9687 86.4853 34.9687 86.4853L27.9346 82.7886C27.9346 82.7886 22.4991 79.4133 22.9787 77.3238C23.4583 75.2343 25.0017 58.6793 25.0017 58.6793Z",
  fill: "#3F3D56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.6609 58.6793C18.6609 58.6793 15.3056 59.0008 15.1458 59.3222C14.9859 59.6437 10.1099 61.0099 10.4297 62.4564C10.7494 63.903 15.1458 76.8416 13.2273 79.2526C11.3089 81.6635 8.1116 85.0388 9.23067 85.3602C10.3497 85.6817 12.2681 84.8781 14.1866 85.3602C16.105 85.8424 20.5812 81.8242 20.1016 77.4845C19.622 73.1449 20.0979 59.8044 18.6609 58.6793Z",
  fill: "#3F3D56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.656 89.3785V90.9858C26.656 90.9858 27.4553 94.6825 24.8974 94.5218C22.3396 94.3611 23.9382 90.0214 23.9382 90.0214L24.0981 88.5748L26.656 89.3785Z",
  fill: "#FFB8B8"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.4618 89.5392C19.4618 89.5392 21.2203 93.2359 19.4618 93.5574C17.7033 93.8789 16.4243 91.4679 16.4243 90.825C16.4243 90.1821 19.4618 89.5392 19.4618 89.5392Z",
  fill: "#FFB8B8"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.1435 52.652C17.3201 52.652 17.4632 52.3642 17.4632 52.0091C17.4632 51.654 17.3201 51.3662 17.1435 51.3662C16.9669 51.3662 16.8237 51.654 16.8237 52.0091C16.8237 52.3642 16.9669 52.652 17.1435 52.652Z",
  fill: "#FFB8B8"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.5761 52.652C26.7527 52.652 26.8958 52.3642 26.8958 52.0091C26.8958 51.654 26.7527 51.3662 26.5761 51.3662C26.3995 51.3662 26.2563 51.654 26.2563 52.0091C26.2563 52.3642 26.3995 52.652 26.5761 52.652Z",
  fill: "#FFB8B8"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3464 60.7688C14.3464 60.7688 10.3497 60.7688 10.5096 62.3761C10.6694 63.9834 15.945 91.6287 15.945 91.6287C15.945 91.6287 18.1832 89.5392 20.1016 90.0214L14.3464 60.7688Z",
  fill: "#3F3D56"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.8532 61.251C29.8532 61.251 33.8499 62.0546 33.8499 64.4655C33.8499 66.8765 28.0946 90.0214 27.2953 90.0214C26.496 90.0214 23.4585 89.5392 23.4585 88.7356C23.4585 87.9319 29.8532 61.251 29.8532 61.251Z",
  fill: "#3F3D56"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M28.974 65.9926L25.377 80.1352C25.377 80.1352 27.0556 67.7606 28.974 65.9926Z",
  fill: "black"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M14.9829 64.0052L18.6208 82.4961C18.6208 82.4961 17.4581 65.0719 14.9829 64.0052Z",
  fill: "black"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.8598 56.7506C24.4203 56.7506 26.4959 54.6637 26.4959 52.0895C26.4959 49.5152 24.4203 47.4283 21.8598 47.4283C19.2993 47.4283 17.2236 49.5152 17.2236 52.0895C17.2236 54.6637 19.2993 56.7506 21.8598 56.7506Z",
  fill: "#FFB8B8"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.6109 47.3476L21.0762 45.5228L25.8616 46.2693L26.8516 50.6657L24.3871 50.5706L23.6986 48.9553V50.5438L22.5613 50.4999L21.9012 47.9283L21.4887 50.6657L17.4458 50.5829L17.6109 47.3476Z",
  fill: "#2F2E41"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.5745 20.2872L67.6636 24.8565L83.7928 33.3684L89.2267 17.3809",
  fill: "#F2F2F2"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.4212 30.565L90.5466 13.7088L74.1699 5.60669L67.292 22.0531L83.4212 30.565Z",
  fill: "#E9663A"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.7827 12.0526L73.6626 12.2888L86.061 18.6581L86.181 18.4218L73.7827 12.0526Z",
  fill: "white"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72.853 14.2952L72.7329 14.5315L85.1313 20.9007L85.2514 20.6645L72.853 14.2952Z",
  fill: "white"
});

var SvgNoJournals = function SvgNoJournals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 139,
    height: 125,
    viewBox: "0 0 139 125",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoJournals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noJournals.fc9a9880.svg";
export { ForwardRef as ReactComponent };